/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import FilterTable from "./FilterTable";

// import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import ChevronRight from './../../assets/icons/ChevronRight';
import ChevronLeft from './../../assets/icons/ChevronLeft';
import { getPageList } from './../../utils/Table';
import {
  flexRender,
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";

const Table = forwardRef(
  (
    {
      columns,
      tableData,
      tableName,
      // tableLoading,
      tableFetchApi,
      pagination = true,
      setQuery
    },
    ref
  ) => {
    // const dispatch = useDispatch();
    // let [searchParams, setSearchParams] = useSearchParams();

    const firstRender = useRef(true);

    const [columnFilters, setColumnFilters] = useState([]);
    const [FilterParams, setFilterParams] = useState(null);
    const [Pagination, setPagination] = useState({
      page: 1,
      limit: 10,
    });

    useEffect(() => {
      setQuery(Pagination)
    }, [Pagination]);

    useEffect(() => {
      if (firstRender.current) {
        firstRender.current = false;
        return;
      }
      handleFilterData(columnFilters);
    }, [columnFilters]);

    // useEffect(() => {
    //   if (firstRender.current) {
    //     firstRender.current = false;
    //     return;
    //   }
    //   fetchTableData(
    //     {
    //     pageNumber: Pagination.pageIndex + 1,
    //     pageSize: Pagination.pageSize,
    //     ...(FilterParams || {}),
    //   }
    // );
    //   searchParams.set([tableName + "-page"], Pagination.pageIndex + 1);
    //   setSearchParams(searchParams);
    // }, [Pagination]);

    useImperativeHandle(ref, () => {
      return { fetchTableData };
    });

    const handleFilterData = (params) => {
      var filterData = {};
      params?.forEach((p) => (filterData[p.id] = p.value));
      setFilterParams(filterData, {
        // ...filterData,
        // pageNumber: Pagination.pageIndex + 1,
        // pageSize: Pagination.pageSize,
      });

      fetchTableData({
        // ...filterData,
        // pageNumber: Pagination.pageIndex + 1,
        // pageSize: Pagination.pageSize,
      });
    };

    const fetchTableData = (data) => {
      // dispatch(
      tableFetchApi(
        data || {
          // pageNumber: Pagination.pageIndex + 1,
          // pageSize: Pagination.pageSize,
          ...(FilterParams || {}),
        }
      );
      // );
    };


    const getIndex = (index) =>
      String((Pagination.page - 1) * Pagination.limit + index + 1).padStart(
        2,
        "0",
      );

    console.log(tableData, "ia")

    const table = useReactTable({
      columns,
      data: tableData?.data || [],
      state: {
        columnFilters,
        // Pagination,
      },
      rowCount: tableData?.total,
      getCoreRowModel: getCoreRowModel(),
      // onPaginationChange: setPagination,
      onColumnFiltersChange: setColumnFilters,
      manualFiltering: true,
      manualPagination: true,
    });

    return (
      <div className="box-border inline-block align-middle overflow-hidden w-full h-full">
        <div className="w-full h-full realtive overflow-auto w">
          <table className="w-full">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr className="bg-white" key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <th
                      className={[
                        "text-base leading-4 text-gray font-normal pt-6 pb-4 text-left content-start",
                        header.column.columnDef?.style || "",
                        header.column.columnDef?.headerStyle || "",
                      ].join(" ")}
                      key={header.id}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}

                      {header.column.getCanFilter() ? (
                        <div>
                          <FilterTable column={header.column} />
                        </div>
                      ) : null}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row, i) => (
                <tr
                  className={[
                    "text-gray-dark_text font-medium text-sm",
                    i % 2 !== 0 ? "bg-white" : "bg-gray-background",
                  ].join(" ")}
                  key={row.id}
                >
                  {row.getVisibleCells().map((cell) => (
                    <td
                      className={[
                        `py-6 w-[${cell.column.getSize()}px]`,
                        cell.column.columnDef?.style || "",
                        cell.column.columnDef?.bodyStyle || "",
                      ].join(" ")}
                      key={cell.id}
                    >
                      {cell.column.columnDef?.indexed
                        ? getIndex(i)
                        : flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}

                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>


          <div>
            {/* Pagination Part */}
            {
              pagination &&
              (
                <div className="flex items-center gap-2 justify-between p-6 border-t border-t-background w-full">
                  {/* limit */}
                  <select onChange={e => setPagination({page:1,limit:e.target.value})} className="p-2 border border-blue rounded-lg">
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                  </select>
                  {/*  Pagination */}
                  <div className="flex items-center w-fit gap-2">
                    <button
                      className="p-2"
                      onClick={() => setPagination(prev => ({ ...prev, page: --Pagination.page }))}
                      disabled={Pagination.page + 1 == 1}
                    >
                      <ChevronLeft
                        color={
                          Pagination.page + 1 == 1 ? "#98AAB4" : "#474350"
                        }
                        stroke={{ strokeWidth: "2" }}
                      />
                    </button>
                    <div className="flex items-center gap-2">
                      {

                        Array.from({ length: Math.ceil(tableData?.total / Pagination.limit) }, (a, b) => b + 1).map((pageNumberInd, i) => (
                          <button
                            disabled={Pagination.page == pageNumberInd}
                            onClick={() => setPagination(prev => ({ ...prev, page: pageNumberInd }))}
                            className={[
                              "flex justify-center items-center text-xs font-normal px-2 py-1 w-5 h-5 rounded-[4px]",
                              Pagination.page == pageNumberInd
                                ? "bg-blue text-white cursor-default"
                                : "text-gray cursor-pointer",
                            ].join(" ")}
                            key={i}
                          >
                            <span className="w-fit h-fit">
                              {pageNumberInd || "..."}
                            </span>
                          </button>
                        ))}
                    </div>
                    <button
                      className="p-2"
                      onClick={() => setPagination(prev => ({ ...prev, page: ++Pagination.page }))}
                      disabled={
                        Pagination.page >= table.getPageOptions()?.length
                      }
                    >
                      <ChevronRight
                        width="16"
                        height="16"
                        stroke={{ strokeWidth: "2" }}
                        color={
                          Pagination.page >= table.getPageOptions()?.length
                            ? "#98AAB4"
                            : "#474350"
                        }
                      />
                    </button>
                  </div>

                </div>
              )
            }
          </div>
        </div>
      </div>
    );
  }
);

export default Table;
